import ImgLogoInventory from "../assets/svg/ImgLogoInventory.svg";
import {
    apiAddWarehouses,
    apiGetWarehouse,
    apiUpdateWarehouse,
    apiWarehouseShortage,
    apiWarehouseStock,
} from "../api/warehouseApi";
import { NumberComponent } from "components/Table/CellComponents";

const byProductTableColumns = [
    {
        name: "کد حسابداری",
        key: "accountingCode",
        filterParams: {
            column: "accountingCode",
            columnType: "string",
        },
    },
    {
        name: "دسته بندی",
        key: "category",
        getValue: (item) => {
            return item.category;
        },
        filterParams: {
            subColumn: "category",
            columnType: "string",
            relationModelName: "ProductCategory",
            relationColumn: "title",
        },
    },
    {
        name: "نام کالا",
        key: "title",
        filterParams: {
            column: "title",
            columnType: "string",
        },
    },
    {
        name: "کد کالا",
        key: "code",
        filterParams: {
            column: "code",
            columnType: "string",
        },
    },
    {
        name: "بارکد",
        key: "barcode",
        getValue: (item) => {
            let barcode = "";
            item?.product_bill?.Product.Barcodes?.map((b) => (barcode += (barcode.length > 0 ? "; " : "") + b.barcode));
            return barcode.length > 0 ? barcode : "-";
        },
        filterParams: {
            column: "barcode",
            columnType: "string",
        },
    },
    {
        name: "واحد",
        key: "unit",
        filterParams: {
            column: "unit",
            columnType: "string",
        },
    },
    {
        name: "جمع کل",
        key: "totalAmount",
        getValue: (item) => {
            return item.totalAmount;
        },
        filterParams: {
            subColumn: "totalAmount",
            columnType: "number",
        },
    },
];
const byInventoryTableColumns = [
    {
        name: "کد حسابداری",
        key: "accountingCode",
        getValue: (item) => {
            return item.product_bill?.Product.accountingCode;
        },
        filterParams: {
            column: "accountingCode",
            columnType: "string",
        },
    },
    {
        name: "دسته بندی",
        key: "category",
        getValue: (item) => {
            return item.product_bill?.Product.Category.title;
        },
        filterParams: {
            column: "category",
            columnType: "string",
            relationModelName: "ProductCategory",
            relationColumn: "title",
        },
    },
    {
        name: "نام کالا",
        key: "title",
        getValue: (item) => {
            return item.product_bill?.Product.title;
        },
        filterParams: {
            column: "title",
            columnType: "string",
        },
    },
    // {
    //     name: "دسته بندی",
    //     key: "category",
    //     getValue: (item) => {
    //         return item.product_bill.Product.category
    //     },
    // },
    {
        name: "کد کالا",
        key: "code",
        getValue: (item) => {
            return item.product_bill?.Product.code;
        },
        filterParams: {
            column: "code",
            columnType: "string",
        },
    },
    {
        name: "بارکد",
        key: "barcode",
        getValue: (item) => {
            let barcode = "";
            item?.product_bill?.Product.Barcodes?.map((b) => (barcode += (barcode.length > 0 ? "; " : "") + b.barcode));
            return barcode.length > 0 ? barcode : "-";
        },
        filterParams: {
            column: "barcode",
            columnType: "string",
        },
    },
    {
        name: "واحد",
        key: "unit",
        getValue: (item) => {
            return item.product_bill?.Product.unit;
        },
        filterParams: {
            column: "unit",
            columnType: "string",
        },
    },

    // {
    //     name: "نقطه سفارش",
    //     key: "product_bill",
    //     getValue: (item) => {
    //         return item.product_bill.Product
    //     },
    // },
    // {
    //     name: "تعداد حسابداری",
    //     key: "accountingQuantity",
    //     price: true,
    //     getValue: (item) => {
    //         return item.product_bill?.quantity
    //     },
    // },
    {
        name: "موجودی اول دوره",
        key: "quantityFirstPeriod",
        price: true,
        filterParams: {
            column: "quantityFirstPeriod",
            columnType: "number",
        },
        searchType: "quantitative",
    },
    {
        name: "ورود",
        key: "increase",
        price: true,
        filterParams: {
            column: "increase",
            columnType: "number",
        },
        searchType: "quantitative",
    },
    { name: "ارزش کالا براساس میانگین قیمت خرید",
        price: true,
        filterParams: {
            column: "totalMeanResult",
            columnType: "number",
        },
        searchType: "quantitative",
        key: "totalMeanResult"
    
    },

    {
        name: "خروج",
        key: "decrease",
        price: true,
        filterParams: {
            column: "decrease",
            columnType: "number",
        },
        searchType: "quantitative",
    },
    {
        name: "موجودی کل",
        key: "quantity",
        price: true,
        filterParams: {
            column: "quantity",
            columnType: "number",
        },
        searchType: "quantitative",
    },
    // {
    //     name: "موجودی حسابداری",
    //     key: "count",
    //     price: true,
    //     filterParams: {
    //         column: "count",
    //         columnType: "quantity",
    //     },
    //     searchType: "quantitative",
    // },
    {
        name: "ارزش کالا (قیمت خرید)",
        key: "total_price",
        price: true,
        filterParams: {
            column: "total_price",
            columnType: "number",
        },
        searchType: "quantitative",
    },
];
const byInventoryShortageTableColumns = [
    {
        name: "کد حسابداری",
        key: "accountingCode",
        getValue: (item) => {
            return item.product_bill?.Product.accountingCode;
        },
        filterParams: {
            column: "accountingCode",
            columnType: "string",
        },
    },
    {
        name: "دسته بندی",
        key: "category",
        getValue: (item) => {
            return item.product_bill?.Product.Category.title;
        },
        filterParams: {
            column: "category",
            columnType: "string",
            relationModelName: "ProductCategory",
            relationColumn: "title",
        },
    },
    {
        name: "نام کالا",
        key: "title",
        getValue: (item) => {
            return item.product_bill?.Product.title;
        },
        filterParams: {
            column: "title",
            columnType: "string",
        },
    },
    {
        name: "کد کالا",
        key: "code",
        getValue: (item) => {
            return item.product_bill?.Product.code;
        },
        filterParams: {
            column: "code",
            columnType: "string",
        },
    },
    {
        name: "بارکد",
        key: "barcode",
        getValue: (item) => {
            let barcode = "";
            item?.product_bill?.Product.Barcodes?.map((b) => (barcode += (barcode.length > 0 ? "; " : "") + b.barcode));
            return barcode.length > 0 ? barcode : "-";
        },
        filterParams: {
            column: "barcode",
            columnType: "string",
        },
    },
    {
        name: "واحد",
        key: "unit",
        getValue: (item) => {
            return item.product_bill?.Product.unit;
        },
        filterParams: {
            column: "unit",
            columnType: "string",
        },
    },
    {
        name: "موجودی اول دوره",
        key: "quantityFirstPeriod",
        price: true,
        filterParams: {
            column: "quantityFirstPeriod",
            columnType: "number",
        },
        searchType: "quantitative",
    },
    {
        name: "ورود",
        key: "increase",
        price: true,
        filterParams: {
            column: "increase",
            columnType: "number",
        },
        searchType: "quantitative",
    },
    {
        name: "خروج",
        key: "decrease",
        price: true,
        filterParams: {
            column: "decrease",
            columnType: "number",
        },
        searchType: "quantitative",
    },
    {
        name: "موجودی کل",
        key: "quantity",
        price: true,
        filterParams: {
            column: "total",
            columnType: "number",
        },
        searchType: "quantitative",
        Component: NumberComponent,
    },
];
const searchParams = new URLSearchParams(document.location.search);
const warehouseId = parseInt(searchParams.get("warehouseId") || "0");
export const inventorySupplyIndexData = [
    {
        title: "بر اساس انبار",
        description: "",
        key: "inventorySupply",
        label: "موجودی انبار",
        pluralLabel: "موجودی انبار",
        pageTitle: "موجودی انبار",
        pageDescription: "گزارش موجودی کالاها و انبارها",
        tableColumns: byInventoryTableColumns,
        disableDateFilter: true,
        id: warehouseId,
        queryParamKey: "warehouseId",
        actions: {
            fetch: apiWarehouseStock,
        },
    },
    {
        title: "بر اساس کالا",
        description: "",
        key: "inventorySupplyByProduct",
        label: "موجودی انبار",
        pluralLabel: "موجودی انبار",
        pageTitle: "موجودی انبار",
        pageDescription: "گزارش موجودی کالاها و انبارها",
        tableColumns: byProductTableColumns,
        dynamicColumns: "warehouses",
        disableDateFilter: true,
        actions: {
            fetch: apiWarehouseStock,
            // disableMidComponent: true,
        },
    },
];

export const inventoryShortageIndexData = [
    {
        title: "کسری انبار",
        description: "",
        key: "inventoryShortage",
        label: "کسری انبار",
        pluralLabel: "کسری انبار",
        pageTitle: "کسری انبار",
        pageDescription: "گزارش کسری کالاها و انبارها",
        tableColumns: byInventoryShortageTableColumns,
        disableDateFilter: true,
        id: warehouseId,
        queryParamKey: "warehouseId",
        actions: {
            fetch: apiWarehouseShortage,
        },
    },
];

export const inventoryFormData = {
    key: "warehouse",
    title: "انبار",
    addFunction: apiAddWarehouses,
    getFunction: apiGetWarehouse,
    updateFunction: apiUpdateWarehouse,
    navigation: {
        title: "افزودن انبار",
        // description: 'ثبت اطلاعات انبار',
        backTitle: "بازگشت",
        backUrl: "/inventories",
    },
    summaryInfo: {
        key: "warehouse",
        primaryTitleKey: "title",
        addTempTitle: "افزودن انبار جدید",
        saveTitle: "ذخیره انبارها",
        defaultImage: ImgLogoInventory,
    },
    tabs: [
        {
            key: "inventory",
            name: "انبار",
            form: {
                main: {
                    wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
                    imagePicker: {
                        active: false,
                    },
                    accountingCode: {
                        wrapperClass: "col-lg-5 col-md-5 col-sm-5 col-xs-12 offset-1 offset-xs-0 style-padding-inputs",
                        active: true,
                        type: "accountingCode",
                        name: "accountingCode",
                        label: "کد حسابداری",
                        primary: true,
                        maxLength: 20,
                        options: [
                            {
                                label: "اتوماتیک",
                                value: true,
                            },
                            {
                                label: "دستی",
                                value: false,
                            },
                        ],
                    },
                    status: {
                        wrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-12",
                        type: "status",
                        name: "active",
                        active: true,
                        primary: true,
                    },
                    radioInput: {
                        wrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-12 ",
                        active: true,
                        type: "radioInput",
                        name: "default",
                        label: "پیش فرض",
                        options: [
                            {
                                title: "بله",
                                value: 1,
                            },
                            {
                                title: "خیر",
                                value: 0,
                            },
                        ],
                    },
                    inputs: [
                        {
                            wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12 style-padding-inputs",
                            name: "title",
                            label: "نام انبار",
                            maxLength: 32,
                            required: true,
                            primary: true,
                        },
                        {
                            wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12 style-padding-inputs",
                            name: "warehouseKeeper",
                            label: "انباردار",
                            maxLength: 32,
                            placeholder: "محمدرضا فرهودی",
                        },
                        {
                            wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12 style-padding-inputs",
                            type: "number",
                            name: "phone",
                            label: "تلفن",
                            maxLength: 16,
                            placeholder: "********021",
                        },
                        {
                            wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12 style-padding-inputs",
                            name: "address",
                            label: "آدرس",
                            maxLength: 128,
                            placeholder: "کیلومتر 5 جاده مخصوص",
                        },
                        {
                            wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12 style-padding-inputs",
                            type: "selectBox",
                            name: "branch",
                            label: "محدود کردن انبار به شعبه انتخابی",
                            showInput: true,
                            options: "branches",
                        },
                        {
                            wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12 style-padding-inputs self-end",
                            type: "checkbox",
                            name: "removeBranch",
                            label: "حذف محدودیت",
                            showInput: true,
                        },
                        {
                            wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12 style-padding-inputs self-end mt-5",
                            type: "checkbox",
                            name: "negativeBalance",
                            label: "ثبت حواله در صورت کمبود موجودی",
                            showInput: true,
                        }
                    ],
                },
            },
        },
    ],
};
